var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","color":"primary","dark":""}},[_c('div',{staticClass:"d-flex align-center"},[_c('h1',[_vm._v("EGMOKKA")])]),_c('v-spacer'),_c('h4',[_vm._v("v1.0")])],1),_c('v-main',[_c('HelloWorld')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }